import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SelectOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Modal, Row, Spin } from 'antd';
import { connect } from 'react-redux';
import './TsResercationsConfirm.scss';
import {
  translateAgreementTypeClassificator as tAgreementType,
  translateTsFuelGenerationClassificator as tFuelGeneration,
  translateTsFuelTypeClassificator as tFuelType,
} from '../../utils/translateHelpers';
import { goToAccountGOSPreTradingAgreementDetails } from '../../utils/gotoLink';
import { FormActions } from '../../components';
import { Form, Field } from 'react-final-form';
import { FORM_RESERVATION_CONFIRM } from '../../constants/formKeys';
import { NumberField } from '../../atoms';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './ValidateSchema';
import {
  getReservationDetailsModal,
  hideReservationDetailsModal,
  showReservationDetailsModal,
} from '../../actions/actionCreators/modalsActionCreators';
import FormStateToRedux from '../FormStateToRedux';
import { formReservationConfirmFields } from '../../constants/forms/formReservationConfirm';
import dayjs from '../../utils/dayjs';
import { availableStatisticsTableFields } from '../../constants/availableStatisticsTableFields';
import { TsReservationsConfirmDetailsView } from '../TsReservationsConfirmDetails/TsReservationsConfirmDetailsView';
import { reserveAndConfirm } from '../../actions/actionCreators/accountGOSAvailableStatisticsActionCreators';

export class TsReservationsConfirm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    registerCode: PropTypes.string.isRequired,
    agreement: PropTypes.object.isRequired,
    statistics: PropTypes.array.isRequired,
    hideModal: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    reservationDetailsModal: PropTypes.bool.isRequired,
    showReservationDetailsModal: PropTypes.func.isRequired,
    reserveAndConfirm: PropTypes.func.isRequired,
  };

  state = {
    loading: false,
    checkboxState: false,
  };

  onSubmit = async (values) => {
    this.setState({ loading: true });
    const { statistics, agreement, onSuccess, hideModal } = this.props;

    const tsPairs = statistics.map((item) => {
      return {
        tsIds: item[availableStatisticsTableFields.GROUPED_STATISTICS_IDS],
        amount:
          item[availableStatisticsTableFields.NATURAL_ENERGY_TRANSFER_AMOUNT],
      };
    });

    try {
      const result = await this.props.reserveAndConfirm({
        transferNow: true,
        tsAgreementId: agreement.id,
        tsPairs,
        ...values,
      });

      if (result?.error) {
        hideModal();
        return;
      }
      await onSuccess?.();
      hideModal();
    } catch (error) {
      console.error('TsReservationsConfirm submit failed:', error);
      hideModal();
    } finally {
      this.setState({ loading: false });
    }
  };

  handleView(agreementId) {
    this.props.hideModal();
    goToAccountGOSPreTradingAgreementDetails(
      this.props.registerCode,
      agreementId
    );
  }

  handleReservationDetailsModal = () => {
    const { showReservationDetailsModal } = this.props;
    showReservationDetailsModal();
  };

  renderRow = (label, value) => (
    <div>
      <span>{label}: </span>
      <span>{value}</span>
    </div>
  );

  render() {
    const {
      t,
      agreement,
      statistics,
      hideModal,
      reservationDetailsModal,
      hideReservationDetailsModal,
    } = this.props;

    const { loading, checkboxState } = this.state;

    const naturalAmountMj = statistics.reduce(
      (total, item) =>
        total +
        item[availableStatisticsTableFields.NATURAL_ENERGY_TRANSFER_AMOUNT],
      0
    );
    const calculatedAmountMj = statistics.reduce(
      (total, item) =>
        total +
        item[availableStatisticsTableFields.CALCULATED_ENERGY_TRANSFER_AMOUNT],
      0
    );
    const fulfilledPercentage = Math.round(
      (naturalAmountMj / agreement.naturalAmountMj) * 100
    );

    const validate = makeRffValidateFromLegacy(validateSchema, this.props);

    return (
      <Spin key="ReservationConfirmLoading" spinning={loading}>
        <Form
          onSubmit={this.onSubmit}
          validate={validate}
          initialValues={{
            [formReservationConfirmFields.PRICE]: agreement.unitPrice,
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_RESERVATION_CONFIRM} />
              <Row gutter={32}>
                <Col span={24} className="detail-container">
                  <div>
                    <span>{t('confirm.agreementNr')}: </span>
                    <a onClick={() => this.handleView(agreement.id)}>
                      {agreement.id}
                    </a>
                  </div>
                  {this.renderRow(
                    t('confirm.counterparty'),
                    agreement.counterpartyName
                  )}
                  {this.renderRow(
                    t('confirm.createdAt'),
                    dayjs().format('DD.MM.YYYY')
                  )}
                  <br />
                  {this.renderRow(
                    t('confirm.agreementType'),
                    tAgreementType(agreement.agreementType)
                  )}
                  {this.renderRow(
                    t('confirm.fuelType'),
                    tFuelType(agreement.fuelType)
                  )}
                  {this.renderRow(
                    t('confirm.fuelGeneration'),
                    tFuelGeneration(agreement.fuelGeneration)
                  )}
                  <br />
                  {this.renderRow(
                    t('confirm.naturalAmountMj'),
                    naturalAmountMj.toFixed(1)
                  )}
                  {this.renderRow(
                    t('confirm.multiplier'),
                    agreement.multiplier
                  )}
                  {this.renderRow(
                    t('confirm.calculatedAmountMj'),
                    calculatedAmountMj.toFixed(1)
                  )}
                  {this.renderRow(
                    t('confirm.fulfilledPercentage'),
                    agreement.agreementType === 'ENTIRE'
                      ? t('confirm.none')
                      : fulfilledPercentage
                  )}
                  <br />
                  {this.renderRow(
                    t('confirm.details'),
                    <Button
                      shape="circle"
                      icon={<SelectOutlined />}
                      size="small"
                      type="primary"
                      title={t('confirm.viewBtn')}
                      onClick={() => this.handleReservationDetailsModal()}
                    />
                  )}
                  <br />
                  <Field
                    min={0}
                    step={0.001}
                    precision={3}
                    name={formReservationConfirmFields.PRICE}
                    label={t('confirm.price')}
                    component={NumberField}
                    isFloat
                  />
                  <br />
                </Col>
              </Row>
              <>
                <Row gutter={32}>
                  <Col span={24}>
                    <Checkbox
                      onChange={(event) =>
                        this.setState({
                          checkboxState: event.target.checked,
                        })
                      }
                      checked={checkboxState}
                    >
                      {t('confirm.checkboxInfo')}
                    </Checkbox>
                  </Col>
                </Row>
                <br />
                <FormActions>
                  <Button onClick={hideModal}>{t('confirm.cancel')} </Button>
                  <Button
                    disabled={!checkboxState}
                    type="primary"
                    htmlType="submit"
                  >
                    {t('confirm.confirm')}
                  </Button>
                </FormActions>
              </>
              {reservationDetailsModal && (
                <Modal
                  onCancel={hideReservationDetailsModal}
                  open
                  footer={false}
                  title={t('confirm.details')}
                  witdth="600px"
                >
                  <TsReservationsConfirmDetailsView
                    t={t}
                    agreement={agreement}
                    statistics={statistics}
                    hideModal={hideReservationDetailsModal}
                  />
                </Modal>
              )}
            </form>
          )}
        />
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  reservationDetailsModal: getReservationDetailsModal(state),
});

const mapDispatchToProps = {
  showReservationDetailsModal,
  hideReservationDetailsModal,
  reserveAndConfirm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TsReservationsConfirm);
